import { render, staticRenderFns } from "./AssistantCategories.vue?vue&type=template&id=1eb7d2f7&scoped=true"
import script from "./AssistantCategories.vue?vue&type=script&lang=js"
export * from "./AssistantCategories.vue?vue&type=script&lang=js"
import style0 from "./AssistantCategories.vue?vue&type=style&index=0&id=1eb7d2f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb7d2f7",
  null
  
)

export default component.exports